// tslint:disable:max-line-length
import * as React from 'react';

export const error = () => (
    <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.96 13.98H.959c-.737 0-1.198-.805-.83-1.448L6.13 2.05a.954.954 0 0 1 1.659 0l6 10.48c.369.644-.092 1.449-.829 1.449"/>
        <path fill="#FFF" d="M8 12.03c0 .581-.465 1.05-1.04 1.05s-1.042-.469-1.042-1.05c0-.579.467-1.05 1.041-1.05.576 0 1.042.471 1.042 1.05M6.96 5.49c-.575 0-1.042.47-1.042 1.05 0 .58.314 4.172.89 4.172h.303c.576 0 .89-3.592.89-4.172 0-.58-.467-1.05-1.042-1.05"/>
    </svg>
);

// tslint:enable:max-line-length
